const ON_CHANGE_DEBOUNCE_TIMER = 300,
  currentDate = new Date(),
  PUB_SUB_EVENTS = {
    'cartUpdate': "cart-update",
    'quantityUpdate': "quantity-update",
    'variantChange': "variant-change"
  },
  POST_LINK_INT = "xml_eval";
let subscribers = {};
function subscribe(arg, arg2) {
  return subscribers[arg] === undefined && (subscribers[arg] = []), subscribers[arg] = [...subscribers[arg], arg2], function v() {
    subscribers[arg] = subscribers[arg].filter(item => {
      return item !== arg2;
    });
  };
}
;
function publish(arg, arg2) {
  subscribers[arg] && subscribers[arg].forEach(item => {
    item(arg2);
  });
}
function activateMindestmenge(root) {
  const data = root && root.querySelector && root.querySelector('script[type="application/json"][data-mm-src]');
  if (!data || window.__scMindestmengeGeladen) return;
  window.__scMindestmengeGeladen = true;
  const script = document.createElement('script');
  script.src = data.dataset.mmSrc;
  document.head.appendChild(script);
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super(), this.addEventListener("click", event => {
      event.preventDefault();
      const value = this.closest("cart-items") || this.closest("cart-drawer-items");
      this.clearCart ? value.clearCart() : value.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
const today = new Date();
const formattedDate = today.toISOString().split('T')[0];
var date = formattedDate;
class CartItems extends HTMLElement {
  constructor() {
    super(), this.lineItemContainer = formatDates(currentDate, date), this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"), this.secondCartItems = document.querySelector("cart-drawer-items");
    const handler = debounce(arg => {
      this.onChange(arg);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    if (!this.lineItemContainer) window.routes.cart_add_url = 'cart';
    this.addEventListener('change', handler.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, arg => {
      if (arg.source === "cart-items") return;
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
  }
  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(response => response.text()).then(response => {
      const result = new DOMParser().parseFromString(response, 'text/html'),
        el = result.querySelector("cart-items");
      this.innerHTML = el.innerHTML;
      activateMindestmenge(this);
    }).catch(error => {
      console.error(error);
    });
  }
  ['updateCart']() {
    const data = JSON.stringify({
      'sections': this.getSectionsToRender().map(item => item.section),
      'sections_url': window.location.pathname
    });
    fetch("/cart/update.js", {
      'method': 'POST',
      'headers': {
        'Content-Type': "application/json"
      },
      'body': data
    }).then(response => response.json()).then(response => {
      this.classList.toggle("is-empty", response.item_count === 0), this.getSectionsToRender().forEach(item => {
        const value = document.getElementById(item.id).querySelector(item.selector) || document.getElementById(item.id);
        value.innerHTML = this.getSectionInnerHTML(response.sections[item.section], item.selector);
      });
      activateMindestmenge(this);
    }).catch(error => {
      console.error(error);
    });
  }
  ['getSectionsToRender']() {
    return [{
      'id': "main-cart-items",
      'section': document.getElementById("main-cart-items").dataset.id,
      'selector': ".js-contents"
    }, {
      'id': "cart-icon-bubble",
      'section': "cart-icon-bubble",
      'selector': ".shopify-section"
    }, {
      'id': "cart-live-region-text",
      'section': "cart-live-region-text",
      'selector': ".shopify-section"
    }, {
      'id': 'main-cart-footer',
      'section': document.getElementById('main-cart-footer').dataset.id,
      'selector': ".js-contents"
    }];
  }
  async updateQuantity(arg, arg2, arg3) {
    this.enableLoading(arg);
    const data = JSON.stringify({
      'line': arg,
      'quantity': arg2,
      'sections': this.getSectionsToRender().map(item => item.section),
      'sections_url': window.location.pathname
    });
    try {
      const v = await fetch('' + routes.cart_change_url, {
          ...fetchConfig(),
          ...{
            'body': data
          }
        }),
        v2 = await v.text(),
        data2 = JSON.parse(v2),
        value = document.getElementById("Quantity-" + arg) || document.getElementById('Drawer-quantity-' + arg),
        elements = document.querySelectorAll(".cart-item");
      if (data2.errors) {
        value.value = value.getAttribute("value"), this.updateLiveRegions(arg, data2.errors);
        return;
      }
      if (!this.lineItemContainer) return;
      if (!data2.sections) {
        const v3 = await fetch(routes.cart_url + '?sections=' + this.getSectionsToRender().map(item => item.section).join(','));
        data2.sections = await v3.json();
      }
      this.classList.toggle("is-empty", data2.item_count === 0);
      const el = document.querySelector("cart-drawer"),
        el2 = document.getElementById("main-cart-footer");
      if (el2) el2.classList.toggle("is-empty", data2.item_count === 0);
      if (el) el.classList.toggle('is-empty', data2.item_count === 0);
      this.getSectionsToRender().forEach(item => {
        const value5 = document.getElementById(item.id).querySelector(item.selector) || document.getElementById(item.id);
        value5.innerHTML = this.getSectionInnerHTML(data2.sections[item.section], item.selector);
      });
      activateMindestmenge(this);
      const value2 = data2.items[arg - 1] ? data2.items[arg - 1].quantity : undefined;
      let value3 = '';
      elements.length === data2.items.length && value2 !== parseInt(value.value) && (typeof value2 === "undefined" ? value3 = window.cartStrings.error : value3 = window.cartStrings.quantityError.replace("[quantity]", value2));
      this.updateLiveRegions(arg, value3);
      const value4 = document.getElementById("CartItem-" + arg) || document.getElementById('CartDrawer-Item-' + arg);
      if (value4 && value4.querySelector('[name=\x22' + arg3 + '\x22]')) el ? trapFocus(el, value4.querySelector("[name=\"" + arg3 + '\x22]')) : value4.querySelector("[name=\"" + arg3 + '\x22]').focus();else {
        if (data2.item_count === 0 && el) trapFocus(el.querySelector(".drawer__inner-empty"), el.querySelector('a'));else document.querySelector(".cart-item") && el && trapFocus(el, document.querySelector(".cart-item__name"));
      }
      if (el) {
        el.checkForClear();
        const el3 = el.querySelector('countdown-timer');
        if (el3) el3.playTimer();
        if (el.querySelector("cart-drawer-gift")) {
          el.checkForClear();
          let list = [],
            list2 = [];
          el.querySelectorAll("cart-drawer-gift").forEach(item => {
            item.getUpdateRequired() && (item.lineInCart() ? item.dataset.selected === "false" && list2.push(item) : item.dataset.selected === "true" && list.push(item));
          });
          if (list2.length > 0) list2[0].removeFromCart();else list.length > 0 && list[0].addToCart();
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        'source': 'cart-items'
      });
    } catch (v) {
      this.querySelectorAll('.loading-overlay').forEach(item => item.classList.add("hidden"));
      const value = document.getElementById("cart-errors") || document.getElementById('CartDrawer-CartErrors');
      value.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(arg);
      if (this.secondCartItems && this.secondCartItems.updateCart) this.secondCartItems.updateCart();
      const customEvent = new CustomEvent('cartQuantityUpdated', {
        'detail': {
          'handle': "handle"
        }
      });
      document.dispatchEvent(customEvent);
    }
  }
  ['updateLiveRegions'](arg, arg2) {
    const value = document.getElementById('Line-item-error-' + arg) || document.getElementById("CartDrawer-LineItemError-" + arg);
    if (value) value.querySelector('.cart-item__error-text').innerHTML = arg2;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const value2 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    value2.setAttribute("aria-hidden", false), setTimeout(() => {
      value2.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(arg, arg2) {
    return new DOMParser().parseFromString(arg, "text/html").querySelector(arg2).innerHTML;
  }
  enableLoading(arg) {
    const value = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    value.classList.add("cart__items--disabled");
    const elements = this.querySelectorAll("#CartItem-" + arg + '\x20.loading-overlay'),
      elements2 = this.querySelectorAll("#CartDrawer-Item-" + arg + " .loading-overlay");
    [...elements, ...elements2].forEach(item => item.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  ['disableLoading'](arg) {
    const value = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    value.classList.remove("cart__items--disabled");
    const elements = this.querySelectorAll("#CartItem-" + arg + " .loading-overlay"),
      elements2 = this.querySelectorAll("#CartDrawer-Item-" + arg + '\x20.loading-overlay');
    elements.forEach(item => item.classList.add('hidden')), elements2.forEach(item => item.classList.add('hidden'));
  }
  clearCart() {
    const data = JSON.stringify({
      'sections': this.getSectionsToRender().map(item => item.section),
      'sections_url': window.location.pathname
    });
    fetch('' + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        'body': data
      }
    }).then(response => {
      return response.text();
    }).then(response => {
      const data2 = JSON.parse(response);
      this.classList.add("is-empty");
      const el = document.querySelector('cart-drawer'),
        el2 = document.getElementById("main-cart-footer");
      if (el2) el2.classList.add("is-empty");
      if (el) el.classList.add("is-empty");
      this.getSectionsToRender().forEach(item => {
        const value = document.getElementById(item.id).querySelector(item.selector) || document.getElementById(item.id);
        value.innerHTML = this.getSectionInnerHTML(data2.sections[item.section], item.selector);
      }), el && trapFocus(el.querySelector('.drawer__inner-empty'), el.querySelector('a')), publish(PUB_SUB_EVENTS.cartUpdate, {
        'source': "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(item => item.classList.add('hidden'));
      const value = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      value.textContent = window.cartStrings.error;
    });
  }
}
customElements.define('cart-items', CartItems);
var search = "search";
!customElements.get('cart-note') && customElements.define("cart-note", class CartNote extends HTMLElement {
  constructor() {
    super(), this.addEventListener("change", debounce(event => {
      const data = JSON.stringify({
        'note': event.target.value
      });
      fetch('' + routes.cart_update_url, {
        ...fetchConfig(),
        ...{
          'body': data
        }
      });
    }, ON_CHANGE_DEBOUNCE_TIMER));
  }
});
;
function handleDiscountForm(event) {
  event.preventDefault();
  const el = event.target.querySelector('[name=cart-discount-field]'),
    el2 = event.target.querySelector(".cart-discount-form__error"),
    value = el.value;
  if (value === undefined || value.length === 0) {
    el2.style.display = "block";
    return;
  }
  el2.style.display = "none";
  const value2 = "/checkout?discount=",
    v = value2 + value;
  window.location.href = v;
}
function handleDiscountFormChange(arg) {
  const elements = document.querySelectorAll(".cart-discount-form__error");
  elements.forEach(item => {
    item.style.display = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input[type=\"search\"]"), this.resetButton = this.querySelector('button[type=\x22reset\x22]');
    this.input && (this.input.form.addEventListener("reset", this.onFormReset.bind(this)), this.input.addEventListener("input", debounce(arg => {
      this.onChange(arg);
    }, 300).bind(this)));
  }
  ['toggleResetButton']() {
    const result = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && result) this.resetButton.classList.remove("hidden");else this.input.value.length === 0 && !result && this.resetButton.classList.add("hidden");
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(event) {
    event.preventDefault(), this.shouldResetForm() && (this.input.value = '', this.input.focus(), this.toggleResetButton());
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super(), this.cachedResults = {}, this.predictiveSearchResults = this.querySelector('[data-predictive-search]'), this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search"), this.isOpen = false, this.abortController = new AbortController(), this.searchTerm = '', this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)), this.input.addEventListener("focus", this.onFocus.bind(this)), this.addEventListener("focusout", this.onFocusOut.bind(this)), this.addEventListener("keyup", this.onKeyup.bind(this)), this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  ['getQuery']() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const result = this.getQuery();
    (!this.searchTerm || !result.startsWith(this.searchTerm)) && this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    this.updateSearchForTerm(this.searchTerm, result), this.searchTerm = result;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected=\x22true\x22]\x20a')) event.preventDefault();
  }
  onFormReset(arg) {
    super.onFormReset(arg), super.shouldResetForm() && (this.searchTerm = '', this.abortController.abort(), this.abortController = new AbortController(), this.closeResults(true));
  }
  onFocus() {
    const result = this.getQuery();
    if (!result.length) return;
    if (this.searchTerm !== result) this.onChange();else this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(this.searchTerm);
  }
  ['onFocusOut']() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();
    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  ['onKeydown'](event) {
    (event.code === "ArrowUp" || event.code === "ArrowDown") && event.preventDefault();
  }
  updateSearchForTerm(arg, arg2) {
    const el = this.querySelector("[data-predictive-search-search-for-text]"),
      v = el?.innerText;
    if (v) {
      if (v.match(new RegExp(arg, 'g')).length > 1) return;
      const result = v.replace(arg, arg2);
      el.innerText = result;
    }
  }
  switchOption(arg) {
    if (!this.getAttribute("open")) return;
    const v = arg === 'up',
      el = this.querySelector('[aria-selected=\x22true\x22]'),
      result = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(item => item.offsetParent !== null);
    let value = 0;
    if (v && !el) return;
    let v2 = -1,
      value2 = 0;
    while (v2 === -1 && value2 <= result.length) {
      result[value2] === el && (v2 = value2), value2++;
    }
    this.statusElement.textContent = '';
    if (!v && el) value = v2 === result.length - 1 ? 0 : v2 + 1;else v && (value = v2 === 0 ? result.length - 1 : v2 - 1);
    if (value === v2) return;
    const value3 = result[value];
    value3.setAttribute('aria-selected', true);
    if (el) el.setAttribute('aria-selected', false);
    this.input.setAttribute("aria-activedescendant", value3.id);
  }
  ['selectOption']() {
    const el = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (el) el.click();
  }
  ['getSearchResults'](arg) {
    const result = arg.replace('\x20', '-').toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[result]) {
      this.renderSearchResults(this.cachedResults[result]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(arg) + "&section_id=predictive-search", {
      'signal': this.abortController.signal
    }).then(response => {
      if (!response.ok) {
        var error = new Error(response.status);
        this.close();
        throw error;
      }
      return response.text();
    }).then(response => {
      const innerHTML = new DOMParser().parseFromString(response, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(item => {
        item.cachedResults[result] = innerHTML;
      }), this.renderSearchResults(innerHTML);
    }).catch(error => {
      if (error?.code === 20) return;
      this.close();
      throw error;
    });
  }
  ['setLiveRegionLoadingState']() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status'), this.loadingText = this.loadingText || this.getAttribute("data-loading-text"), this.setLiveRegionText(this.loadingText), this.setAttribute("loading", true);
  }
  setLiveRegionText(arg) {
    this.statusElement.setAttribute('aria-hidden', "false"), this.statusElement.textContent = arg, setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  ['renderSearchResults'](arg) {
    this.predictiveSearchResults.innerHTML = arg, this.setAttribute('results', true), this.setLiveRegionResults(), this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  ['getResultsMaxHeight']() {
    return this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom, this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + 'px', this.setAttribute("open", true), this.input.setAttribute("aria-expanded", true), this.isOpen = true;
  }
  close(arg = false) {
    this.closeResults(arg), this.isOpen = false;
  }
  closeResults(arg = false) {
    arg && (this.input.value = '', this.removeAttribute("results"));
    const el = this.querySelector("[aria-selected=\"true\"]");
    if (el) el.setAttribute("aria-selected", false);
    this.input.setAttribute("aria-activedescendant", ''), this.removeAttribute("loading"), this.removeAttribute("open"), this.input.setAttribute('aria-expanded', false), this.resultsMaxHeight = false, this.predictiveSearchResults.removeAttribute('style');
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = 'dat' + "a-def" + 'er';
class CartDrawer extends HTMLElement {
  constructor() {
    super(), this.upsellHandles = this.getUpsellHandles(), this.checkForClear(), this.addEventListener('keyup', event => event.code === "Escape" && this.close()), this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this)), this.setHeaderCartIconAccessibility();
    // 20.0.6 (armedion-Befund 11.09.): der Korb kann sich ausserhalb dieser Seite aendern (zweiter Tab, App, Checkout-Zurueck) -> beim Sichtbarwerden abgleichen
    this.onVisibilityChange = () => { if (document.visibilityState === 'visible') this.refreshIfStale(); };
    this.onPageShow = event => { if (event.persisted) this.refreshIfStale(); };
  }
  connectedCallback() {
    document.addEventListener('visibilitychange', this.onVisibilityChange), window.addEventListener('pageshow', this.onPageShow);
  }
  disconnectedCallback() {
    document.removeEventListener('visibilitychange', this.onVisibilityChange), window.removeEventListener('pageshow', this.onPageShow);
  }
  setHeaderCartIconAccessibility() {
    const el = document.querySelector("#cart-icon-bubble"),
      el2 = el.closest('.header__icons');
    el.setAttribute('role', 'button'), el.setAttribute("aria-haspopup", "dialog"), el.addEventListener("click", event => {
      event.preventDefault(), this.open(el);
    }), this.oseid = el2.querySelector("form").dataset[this.dataset.type], el.addEventListener('keydown', event => {
      event.code.toUpperCase() === "SPACE" && (event.preventDefault(), this.open(el));
    });
  }
  // 20.0.6 (armedion-Befund 11.09.): Der Drawer-DOM entsteht nur aus theme-eigenen Add/Change-Antworten. Wurde der Korb
  // ausserhalb dieser Seite gefuellt (zweiter Tab, App, Checkout-Zurueck, 422 nach fremdem Add), zeigte der Drawer beim
  // Oeffnen 0 Artikel. Abgleich gegen /cart.js: weichen Zeilenzahl oder Gesamtmenge ab, wird die Sektion ueber den
  // bestehenden Pfad (renderContents, danach Gift-Reconcile) neu gerendert und die PDP-Mengenregeln nachgezogen.
  refreshIfStale() {
    if (this.refreshing) return Promise.resolve(false);
    const inFlight = () => !!document.querySelector('form[data-type="add-to-cart-form"] [type="submit"][aria-disabled="true"], .cart-item .loading-overlay:not(.hidden), .cart__items--disabled');
    if (inFlight()) return Promise.resolve(false);
    this.refreshing = true;
    const epoch = window.scCartEpoch || 0;
    // Identitaet je Zeile: Variante:Menge in Reihenfolge (Codex F2) — Zeilen derselben Variante mit anderen Properties bleiben ununterscheidbar, Mengen und Reihenfolge nicht
    const domSignature = () => Array.from(this.querySelectorAll('.cart-item')).map(line => { const input = line.querySelector('.quantity__input'); return (input && input.dataset.quantityVariantId ? input.dataset.quantityVariantId : '?') + ':' + (input ? parseInt(input.value) || 0 : 0); }).join('|');
    return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(response => response.json()).then(cart => {
      const serverSignature = cart.items.map(item => item.variant_id + ':' + item.quantity).join('|');
      if (serverSignature === domSignature()) return false;
      if (epoch !== (window.scCartEpoch || 0) || inFlight()) return false;
      return fetch(routes.cart_update_url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: {}, sections: this.getSectionsToRender().map(item => item.id), sections_url: window.location.pathname }) }).then(response => response.json()).then(response => {
        // seit dem Start hat ein lokaler Write begonnen -> dessen Antwort ist die juengere, diese hier verwerfen (Codex F3)
        if (epoch !== (window.scCartEpoch || 0) || inFlight() || !response.sections) return false;
        this.classList.toggle('is-empty', response.item_count === 0);
        this.renderContents(response, true);
        if (this.classList.contains('active')) {
          // Drawer war offen: Fokus-Trap auf den neuen DOM setzen (Codex F5), Spiegel von open()
          const container = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
          if (container) trapFocus(container, this.querySelector('.drawer__inner') || this.querySelector('.drawer__close'));
        }
        document.querySelectorAll('product-info').forEach(info => { if (info.fetchQuantityRules && !info.dataset.originalSection) info.fetchQuantityRules(); });
        return true;
      });
    }).catch(error => { console.error(error); return false; }).finally(() => { this.refreshing = false; });
  }
  ['open'](arg, skipRefresh) {
    if (arg) this.setActiveElement(arg);
    if (!skipRefresh) this.refreshIfStale();
    const el = this.querySelector("[id^=\"Details-\"] summary");
    if (el && !el.hasAttribute("role")) this.setSummaryAccessibility(el);
    setTimeout(() => {
      this.classList.add('animate', "active");
    }), this.addEventListener("transitionend", () => {
      const value = this.classList.contains('is-empty') ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer"),
        value2 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(value, value2);
    }, {
      'once': true
    }), document.body.classList.add('overflow-hidden');
    const el2 = this.querySelector('countdown-timer');
    if (el2) el2.playTimer();
  }
  ['close']() {
    this.classList.remove("active"), removeTrapFocus(this.activeElement), document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const elements = this.querySelectorAll('cart-drawer-upsell[data-toggle=\x22true\x22]'),
      list = [];
    return elements.forEach(item => {
      item.dataset.handle && list.push(item.dataset.handle);
    }), [...new Set(list)]; // 20.0.6-Korrektur (Codex C1-F10): Dedup
  }
  oneNonUpellRemaining() {
    const elements = this.querySelectorAll(".cart-item");
    let value = 0;
    return elements.forEach(item => {
      // 20.0.6: markierte Geschenkzeile eines vorhandenen Blocks zaehlt als Nicht-Artikel; verwaister Marker = Kundenzeile
      if (item.dataset.gift && this.querySelector('cart-drawer-gift[data-gift="' + CSS.escape(item.dataset.gift) + '"]')) { value++; return; }
      this.upsellHandles.forEach(item2 => {
        item.classList.contains("cart-item--product-" + item2) && value++;
      });
    }), elements.length - value <= 1;
  }
  checkForClear() {
    const result = this.oneNonUpellRemaining();
    this.querySelectorAll('cart-remove-button').forEach(item => {
      result ? item.clearCart = true : item.clearCart = false;
    });
  }
  ['setSummaryAccessibility'](arg) {
    arg.setAttribute("role", "button"), arg.setAttribute('aria-expanded', "false"), arg.nextElementSibling.getAttribute('id') && arg.setAttribute("aria-controls", arg.nextElementSibling.id), arg.addEventListener("click", event => {
      event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
    }), arg.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(arg, arg2 = false) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") && this.querySelector(".drawer__inner").classList.remove("is-empty"), this.productId = arg.id, this.getSectionsToRender().forEach(item => {
      const value = item.selector ? document.querySelector(item.selector) : document.getElementById(item.id);
      if (value) value.innerHTML = this.getSectionInnerHTML(arg.sections[item.id], item.selector);
    }), activateMindestmenge(this), this.checkForClear();
    const el = this.querySelector('countdown-timer');
    if (el && el.playTimer) el.playTimer();
    let list = [],
      list2 = [];
    this.querySelectorAll('cart-drawer-gift').forEach(item => {
      item.getUpdateRequired() && (item.lineInCart() ? item.dataset.selected === "false" && list2.push(item) : item.dataset.selected === 'true' && list.push(item));
    });
    if (list2.length > 0) list2[0].removeFromCart();else list.length > 0 && list[0].addToCart();
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (arg2) return;
      this.open(undefined, true);
    });
  }
  getSectionInnerHTML(arg, arg2 = ".shopify-section") {
    let el = new DOMParser().parseFromString(arg, "text/html").querySelector(arg2);
    arg2 === "#CartDrawer" && fixParsedHtml(this, el);
    let innerHTML = el.innerHTML;
    return innerHTML;
  }
  getSectionsToRender() {
    return [{
      'id': 'cart-drawer',
      'selector': "#CartDrawer"
    }, {
      'id': 'cart-icon-bubble'
    }];
  }
  ['getSectionDOM'](arg, arg2 = ".shopify-section") {
    return new DOMParser().parseFromString(arg, "text/html").querySelector(arg2);
  }
  setActiveElement(arg) {
    this.activeElement = arg;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super(), this.cartDrawer = document.querySelector("cart-drawer"), this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      'method': "POST",
      'headers': {
        'Content-Type': "application/json"
      },
      'body': JSON.stringify({
        'updates': {},
        'sections': ["cart-drawer", 'cart-icon-bubble'],
        'sections_url': window.location.pathname
      })
    }).then(response => response.json()).then(response => {
      document.querySelector("cart-drawer").renderContents(response, true);
    }).catch(error => {
      console.error(error);
    });
  }
  getSectionInnerHTML(arg, arg2) {
    let el = new DOMParser().parseFromString(arg, "text/html").querySelector(arg2);
    arg2 === ".drawer__inner" && fixParsedHtml(this.cartDrawer, el);
    let innerHTML = el.innerHTML;
    return innerHTML;
  }
  ['getSectionsToRender']() {
    return [{
      'id': "CartDrawer",
      'section': "cart-drawer",
      'selector': ".drawer__inner"
    }, {
      'id': "cart-icon-bubble",
      'section': "cart-icon-bubble",
      'selector': ".shopify-section"
    }];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
function fixParsedHtml(arg, arg2) {
  const el = arg2.querySelector('.cart-timer');
  if (el) {
    oldTimer = arg.querySelector(".cart-timer");
    if (oldTimer) el.innerHTML = oldTimer.innerHTML;
  }
  const elements = arg.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let elements2 = arg2.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  elements.forEach((item, index) => {
    if (!elements2[index]) return; // 20.0.6-Korrektur (Codex C1-F5): neuer Render ohne dieses Element
    if (item.nodeName.toLowerCase() === "cart-drawer-upsell") elements2[index].dataset.selected = item.dataset.selected;
    elements2[index].dataset.id = item.dataset.id, elements2[index].querySelector("[name=\"id\"]").value = item.querySelector("[name=\"id\"]").value;
    if (elements2[index].querySelector(".upsell__image__img")) elements2[index].querySelector(".upsell__image__img").src = item.querySelector(".upsell__image__img").src;
    if (elements2[index].querySelector(".upsell__variant-picker")) {
      const elements3 = item.querySelectorAll(".select__select");
      elements2[index].querySelectorAll('.select__select').forEach((item2, index2) => {
        item2.value = elements3[index2].value, item2.querySelectorAll("option").forEach(item3 => {
          item3.removeAttribute("selected");
          if (item3.value === elements3[index2].value.trim()) item3.setAttribute('selected', '');
        });
      });
    }
    if (item.dataset.updatePrices === "true") {
      var el2 = elements2[index].querySelector(".upsell__price"),
        el3 = item.querySelector(".upsell__price");
      if (el2 && el3) el2.innerHTML = el3.innerHTML;
    }
  });
}
!customElements.get('product-form') && customElements.define("product-form", class ProductForm extends HTMLElement {
  constructor() {
    super(), this.form = this.querySelector("form"), this.form.addEventListener("submit", this.handleSubmit.bind(this)), this.formIdInput = this.form.querySelector("[name=id]"), this.formIdInput.disabled = false, this.isMain = this.classList.contains("main-product-form"), this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [], this.skipCart = this.formIdInput.dataset.skipCart === "true", this.cart = document.querySelector('cart-drawer') || document.querySelector("cart-notification"), this.isCartUpsell = this.dataset.isCartUpsell === "true", this.submitButton = this.querySelector('[type=\x22submit\x22]'), document.querySelector("cart-drawer") && (this.submitButton.setAttribute("aria-haspopup", "dialog"), this.hasDrawer = true), this.loadingSpinner = this.submitButton.querySelector('.loading-overlay__spinner'), this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section), this.bundleDeals = document.getElementById('bundle-deals-' + this.dataset.section), this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section), this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']"), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.upsells = document.querySelectorAll('.product-info-upsell-' + this.dataset.section), this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section), this.variantInputs = this.form.querySelector(".product-form__variants");
  }
  handleSubmit(event) {
    this.ref = false;
    let value = null,
      v = false;
    event && (event.preventDefault(), event.currentTarget.classList.contains("button--has-spinner") && (value = event.currentTarget, value.classList.add("loading")), event.currentTarget.dataset.skipCartButton === "true" && (v = true));
    if (this.submitButton.getAttribute("aria-disabled") === "true") return;
    this.handleErrorMessage(), this.submitButton.setAttribute("aria-disabled", true);
    if (!value) {
      this.submitButton.classList.add("loading");
      if (this.loadingSpinner) this.loadingSpinner.classList.remove("hidden");
    }
    this.additionalAtcButtons.forEach(item => {
      item.setAttribute("disabled", '');
    });
    this.displayedSubmitButton && (this.displayedSubmitButton.setAttribute("disabled", ''), this.displayedSubmitButton.classList.add("loading"));
    let v2 = false;
    if (this.variantInputs && !this.ref) {
      this.variantInputs.innerHTML = '';
      let value2 = '',
        list = [];
      this.hasDrawer && !this.isCartUpsell && !this.skipCart && this.cart.querySelectorAll('cart-drawer-upsell[data-toggle=\x22true\x22]').forEach(item => {
        item.dataset.selected === "true" && !item.lineInCart() && list.unshift(item.dataset.id);
      });
      if (this.bundleDeals) {
        v2 = true;
        this.dataset.includePdpUpsells === "true" && document.querySelectorAll("product-info-upsell").forEach(item => {
          if (item.dataset.selected === "true") list.unshift(item.dataset.id);
        });
        for (let value3 = 0; value3 < list.length; value3++) {
          value2 += "<input type=\"hidden\" name=\"items[" + value3 + "][quantity]\" value=\"1\"><input type=\"hidden\" name=\"items[" + value3 + '][id]\x22\x20value=\x22' + list[value3] + '\x22>';
        }
        let length = list.length;
        for (let value3 = 0; value3 < this.bundleDeals.formVariants.length; value3++) {
          const value32 = this.bundleDeals.formVariants[value3];
          value2 += "<input type=\"hidden\" name=\"items[" + (value3 + length) + "][quantity]\" value=\"" + value32.quantity + "\"><input type=\"hidden\" name=\"items[" + (value3 + length) + '][id]\x22\x20value=\x22' + value32.id + '\x22>';
        }
        this.variantInputs.innerHTML = value2;
      } else {
        let list2 = [];
        this.quantityGifts && this.quantityGifts.unlockedItems.length > 0 && (list = [...list, ...this.quantityGifts.unlockedItems]);
        for (let v3 = this.upsells.length - 1; v3 >= 0; v3--) {
          this.upsells[v3].dataset.selected === "true" && list.push(this.upsells[v3].dataset.id);
        }
        if (this.mainBundleItems.length === 0) {
          if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) list = [...list, ...this.quantityBreaks.formVariants], list2 = [...this.quantityBreaks.formVariants];else {
            if (list.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
              let value3 = 1;
              if (this.quantityBreaks) value3 = this.quantityBreaks.selectedQuantity;else this.quantityPicker && (value3 = parseInt(this.quantityPicker.querySelector(".quantity__input").value));
              for (let value4 = 0; value4 < value3; value4++) {
                list.push(this.formIdInput.value);
              }
              list2 = [this.formIdInput.value];
            }
          }
        }
        for (let v3 = this.mainBundleItems.length - 1; v3 >= 0; v3--) {
          list.push(this.mainBundleItems[v3].dataset.id), list2.push(this.mainBundleItems[v3].dataset.id);
        }
        if (list.length > 0) {
          v2 = true;
          const list3 = [];
          for (let value3 = 0; value3 < list.length; value3++) {
            const value32 = list[value3],
              result2 = list3.findIndex(arg => arg.id === value32);
            result2 < 0 ? list3.push({
              'id': value32,
              'quantity': 1
            }) : list3[result2].quantity += 1;
          }
          let list4 = [];
          this.customFields.forEach(item => {
            item.dataset.disabled != "true" && list4.push({
              'fieldName': item.fieldName,
              'value': item.prevValue
            });
          });
          this.classList.contains("main-product-form") && (this.sellingPlanInput = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"]"), this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options"), this.appPropertyInputs = document.querySelectorAll('.cl-upload--wrapper\x20input[name^=\x22properties[\x22],\x20.uploadkit-attribute-container\x20input[name^=\x22properties[\x22],\x20.gpo-hidden-inputs\x20input:not(#validator)'));
          for (let value3 = 0; value3 < list3.length; value3++) {
            const value32 = list3[value3];
            value2 += "<input type=\"hidden\" name=\"items[" + value3 + "][quantity]\" value=\"" + value32.quantity + "\"><input type=\"hidden\" name=\"items[" + value3 + "][id]\" value=\"" + value32.id + '\x22>', list2.includes(value32.id) && (list4.forEach(item => {
              value2 += "<input type=\"hidden\" name=\"items[" + value3 + "][properties][" + item.fieldName + ']\x22\x20value=\x22' + item.value + '\x22>';
            }), this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0 && (value2 += "<input type=\"hidden\" name=\"items[" + value3 + "][selling_plan]\" value=\"" + this.sellingPlanInput.value + '\x22>'), this.simpleBundlesContainer && this.simpleBundlesContainer.querySelectorAll('select').forEach(item => {
              const result2 = item.name.match(/properties\[(.*?)\]/);
              if (result2) {
                let v3 = result2[1];
                value2 += '<input\x20type=\x22hidden\x22\x20name=\x22items[' + value3 + "][properties][" + v3 + ']\x22\x20value=\x22' + item.value + '\x22>';
              }
            }), this.appPropertyInputs.forEach(item => {
              let v3 = item.name.match(/properties\[(.*?)\]/)[1];
              value2 += "<input type=\"hidden\" name=\"items[" + value3 + "][properties][" + v3 + ']\x22\x20value=\x22' + item.value + '\x22>';
            }));
          }
          this.variantInputs.innerHTML = value2;
        }
      }
    }
    var result = fetchConfig("javascript");
    result.headers['X-Requested-With'] = "XMLHttpRequest", delete result.headers['Content-Type'];
    var formData = new FormData(this.form);
    if (this.ref) v2 = true;
    this.cart && (formData.append("sections", this.cart.getSectionsToRender().map(item => item.id)), formData.append('sections_url', window.location.pathname), this.cart.setActiveElement(document.activeElement));
    if (v2) {
      const value2 = this.dataset.options ? this.dataset.options.split(',') : [],
        list = ['id', 'quantity', ...value2];
      for (let value3 = 0; value3 < list.length; value3++) {
        formData.delete(list[value3]);
      }
    }
    result.body = formData, fetch('' + routes.cart_add_url, result).then(response => response.json()).then(response => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        const el2 = this.submitButton.querySelector(".sold-out-message");
        if (!el2) return;
        this.submitButton.setAttribute('aria-disabled', true), this.submitButton.querySelector("span").classList.add("hidden"), el2.classList.remove("hidden"), this.error = true;
        return;
      } else {
        if (this.skipCart || v) {
          window.location = '/checkout';
          return;
        } else {
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
        }
      }
      if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {
        'source': "product-form"
      });
      this.error = false;
      const el = this.closest("quick-add-modal");
      el ? (document.body.addEventListener("modalClosed", () => {
        setTimeout(() => {
          this.cart.renderContents(response, this.isCartUpsell);
        });
      }, {
        'once': true
      }), el.hide(true)) : this.cart.renderContents(response, this.isCartUpsell);
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      if (value) value.classList.remove('loading');else {
        this.submitButton.classList.remove('loading');
        if (this.loadingSpinner) this.loadingSpinner.classList.add("hidden");
      }
      this.additionalAtcButtons.forEach(item => {
        item.removeAttribute("disabled");
      });
      this.displayedSubmitButton && (this.displayedSubmitButton.removeAttribute("disabled"), this.displayedSubmitButton.classList.remove("loading"));
      if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
      if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    });
  }
  ['handleErrorMessage'](arg = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message"), this.errorMessageWrapper.toggleAttribute("hidden", !arg), arg && (this.errorMessage.textContent = arg);
  }
});
!customElements.get("product-info") && customElements.define("product-info", class ProductInfo extends HTMLElement {
  constructor() {
    super(), this.deferredMedia = document.querySelector('[' + defMed + ']'), this.input = this.querySelector(".quantity__input"), this.currentVariant = this.querySelector(".product-variant-id"), this.variantSelects = this.querySelector("variant-radios"), this.submitButton = this.querySelector('[type=\x22submit\x22]'), this.form = this.querySelector("#ProductForm-" + this.dataset.section), this.hasUrl = this.dataset.url !== null;
  }
  cartUpdateUnsubscriber = undefined;
  variantChangeUnsubscriber = undefined;
  ['connectedCallback']() {
    if (!this.input) return;
    this.quantityForm = this.querySelector(".product-form__quantity");
    if (!this.quantityForm) return;
    this.setQuantityBoundries();
    !this.dataset.originalSection && (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this)));
    this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, arg => {
      const value = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      if (arg.data.sectionId !== value) return;
      this.updateQuantityRules(arg.data.sectionId, arg.data.html), this.setQuantityBoundries();
    });
    if (!this.form) return;
    if (!this.deferredMedia || !this.deferredMedia.src || !this.deferredMedia.src.includes("net")) this.form.ref = true;
  }
  ['disconnectedCallback']() {
    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber(), this.variantChangeUnsubscriber && this.variantChangeUnsubscriber();
  }
  setQuantityBoundries() {
    const config = {
      'cartQuantity': this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
      'min': this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
      'max': this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
      'step': this.input.step ? parseInt(this.input.step) : 1
    };
    let min = config.min;
    const value = config.max === null ? config.max : config.max - config.cartQuantity;
    if (value !== null) min = Math.min(min, value);
    if (config.cartQuantity >= config.min) min = Math.min(min, config.step);
    this.input.min = min, this.input.max = value, this.input.value = min, publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
  }
  initShareLinks() {
    const el = this.querySelector(".share-url-button");
    if (!el) this.shareUrl = true;
  }
  ['fetchQuantityRules']() {
    if (!this.currentVariant || !this.currentVariant.value) return;
    this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden"), fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(response => {
      return response.text();
    }).then(response => {
      const result = new DOMParser().parseFromString(response, 'text/html');
      this.updateQuantityRules(this.dataset.section, result), this.setQuantityBoundries();
    }).catch(error => {
      console.error(error);
    }).finally(() => {
      this.querySelector('.quantity__rules-cart\x20.loading-overlay').classList.add('hidden');
    });
  }
  updateQuantityRules(arg, arg2) {
    const el = arg2.getElementById("Quantity-Form-" + arg),
      list = [".quantity__input", '.quantity__rules', '.quantity__label'];
    for (let v of list) {
      const el2 = this.quantityForm.querySelector(v),
        el3 = el.querySelector(v);
      if (!el2 || !el3) continue;
      if (v === ".quantity__input") {
        const list2 = ["data-cart-quantity", "data-min", 'data-max', "step"];
        for (let v2 of list2) {
          const attr = el3.getAttribute(v2);
          if (attr !== null) el2.setAttribute(v2, attr);
        }
      } else el2.innerHTML = el3.innerHTML;
    }
  }
});
;
function getFocusableElements(arg) {
  return Array.from(arg.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(item => {
  item.setAttribute("role", "button"), item.setAttribute('aria-expanded', item.parentNode.hasAttribute("open"));
  item.nextElementSibling.getAttribute('id') && item.setAttribute("aria-controls", item.nextElementSibling.id);
  item.addEventListener("click", event => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest("details").hasAttribute("open"));
  });
  if (item.closest('header-drawer')) return;
  item.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(arg, arg2 = arg) {
  var result = getFocusableElements(arg),
    v = result[0],
    v2 = result[result.length - 1];
  removeTrapFocus(), trapFocusHandlers.focusin = event => {
    if (event.target !== arg && event.target !== v2 && event.target !== v) return;
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  }, trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return;
    event.target === v2 && !event.shiftKey && (event.preventDefault(), v.focus()), (event.target === arg || event.target === v) && event.shiftKey && (event.preventDefault(), v2.focus());
  }, document.addEventListener("focusout", trapFocusHandlers.focusout), document.addEventListener("focusin", trapFocusHandlers.focusin), arg2.focus(), arg2.tagName === 'INPUT' && ["search", 'text', "email", 'url'].includes(arg2.type) && arg2.value && arg2.setSelectionRange(0, arg2.value.length);
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(item => {
    item.contentWindow.postMessage('{\x22event\x22:\x22command\x22,\x22func\x22:\x22' + 'pauseVideo' + '\x22,\x22args\x22:\x22\x22}', item.src ? new URL(item.src, location.href).origin : '*');
  }), document.querySelectorAll(".js-vimeo").forEach(item => {
    item.contentWindow.postMessage('{\x22method\x22:\x22pause\x22}', item.src ? new URL(item.src, location.href).origin : '*');
  }), document.querySelectorAll("media-gallery template video").forEach(item => item.pause()), document.querySelectorAll("product-model").forEach(item => {
    if (item.modelViewerUI) item.modelViewerUI.pause();
  });
}
function removeTrapFocus(arg = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (arg) arg.focus();
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const el = event.target.closest('details[open]');
  if (!el) return;
  const el2 = el.querySelector("summary");
  el.removeAttribute("open"), el2.setAttribute('aria-expanded', false), el2.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super(), this.input = this.querySelector("input"), this.changeEvent = new Event("change", {
      'bubbles': true
    }), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.input.addEventListener("change", this.onInputChange.bind(this)), this.querySelectorAll('button').forEach(item => item.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules(), this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
  }
  onInputChange(arg) {
    this.validateQtyRules();
  }
  onButtonClick(event) {
    event.preventDefault();
    const value = this.input.value;
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (value !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
  validateQtyRules() {
    const num = parseInt(this.input.value);
    if (this.input.min) {
      const num2 = parseInt(this.input.min),
        el = this.querySelector(".quantity__button[name='minus']");
      el.classList.toggle("disabled", num <= num2);
    }
    if (this.input.max) {
      const num2 = parseInt(this.input.max),
        el = this.querySelector(".quantity__button[name='plus']");
      el.classList.toggle("disabled", num >= num2);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) this.quantityGifts.unlockGifts(num);
    updateAtcPrice(this.dataset.section, num);
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(arg, arg2) {
  let v;
  return (...arg3) => {
    clearTimeout(v), v = setTimeout(() => arg.apply(this, arg3), arg2);
  };
}
function fetchConfig(arg = "json") {
  // 20.0.6 (Codex Drawer-Refresh F3): jeder theme-eigene Cart-Write zaehlt die Epoche hoch; ein laufender Drawer-Refresh rendert nur, wenn seit seinem Start kein Write begonnen hat
  window.scCartEpoch = (window.scCartEpoch || 0) + 1;
  return {
    'method': "POST",
    'headers': {
      'Content-Type': "application/json",
      'Accept': "application/" + arg
    }
  };
}
function addDays(arg, arg2) {
  var date2 = new Date(arg);
  return date2.setDate(date2.getDate() + arg2), date2;
}
function formatDates(arg, arg2, arg3 = 27) {
  if (!arg || !arg2) return;
  const date2 = new Date(arg2 + "T00:00:00Z"),
    result = date2.getFullYear(),
    result2 = date2.getMonth(),
    result3 = date2.getDate(),
    date3 = new Date(result, result2, result3),
    v = arg - date3,
    result4 = Math.ceil(v / (1000 * 3600 * 24));
  return result4 <= arg3;
}
function checkDateValidity(arg) {
  const date2 = new Date(arg),
    date3 = new Date("2023-01-01T00:00:00Z"),
    result = Math.abs(date2.getDate() - date3.getDate());
  return result % 5 === 0 ? true : false;
}
typeof window.Shopify == "undefined" && (window.Shopify = {});
Shopify.bind = function (arg, arg2) {
  return function () {
    return arg.apply(arg2, arguments);
  };
}, Shopify.setSelectorByValue = function (arg, arg2) {
  for (var value = 0, length = arg.options.length; value < length; value++) {
    var value2 = arg.options[value];
    if (arg2 == value2.value || arg2 == value2.innerHTML) return arg.selectedIndex = value, value;
  }
}, Shopify.addListener = function (arg, arg2, arg3) {
  arg.addEventListener ? arg.addEventListener(arg2, arg3, false) : arg.attachEvent('on' + arg2, arg3);
}, Shopify.postLink = function (arg, arg2) {
  arg2 = arg2 || {};
  var value = arg2.method || "post",
    value2 = arg2.parameters || {},
    el = document.createElement('form');
  el.setAttribute('method', value), el.setAttribute('action', arg);
  for (var v in value2) {
    var el2 = document.createElement("input");
    el2.setAttribute('type', "hidden"), el2.setAttribute("name", v), el2.setAttribute("value", value2[v]), el.appendChild(el2);
  }
  document.body.appendChild(el), el.submit(), document.body.removeChild(el);
}, Shopify.internationalAccessAccept = function () {
  function fn() {
    var value = navigator.language || navigator.userLanguage;
    return value.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
  }
  function fn2() {
    var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return timeZone.startsWith('Europe') || timeZone.startsWith('America') || timeZone.includes("GMT");
  }
  function fn3() {
    var value = Shopify.currency.symbol || '$';
    return value.length === 1;
  }
  function fn4() {
    var result = localStorage.getItem(POST_LINK_INT),
      value = Shopify.postLink ? Shopify.postLink.toString().length : 0;
    if (result === null) return localStorage.setItem(POST_LINK_INT, value.toString()), true;
    return parseInt(result) === value;
  }
  function fn5() {
    return fn() || fn2() && fn3();
  }
  function fn6() {
    return window.performance && typeof window.performance.timing === "object";
  }
  return function () {
    var result = fn5(),
      result2 = fn6(),
      result3 = fn4();
    return Shopify.postLinksRetry = !result3, result && result2 && result3;
  };
}(), Shopify.CountryProvinceSelector = function (arg, arg2, arg3) {
  this.countryEl = document.getElementById(arg), this.provinceEl = document.getElementById(arg2), this.provinceContainer = document.getElementById(arg3.hideElement || arg2), Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)), this.initCountry(), this.initProvince();
}, Shopify.CountryProvinceSelector.prototype = {
  'initCountry': function () {
    var attr = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, attr), this.countryHandler();
  },
  'initProvince': function () {
    var attr = this.provinceEl.getAttribute("data-default");
    attr && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, attr);
  },
  'countryHandler': function (arg) {
    var v = this.countryEl.options[this.countryEl.selectedIndex],
      attr = v.getAttribute("data-provinces"),
      data = JSON.parse(attr);
    this.clearOptions(this.provinceEl);
    if (data && data.length == 0) this.provinceContainer.style.display = 'none';else {
      for (var value = 0; value < data.length; value++) {
        var v = document.createElement('option');
        v.value = data[value][0], v.innerHTML = data[value][1], this.provinceEl.appendChild(v);
      }
      this.provinceContainer.style.display = '';
    }
  },
  'clearOptions': function (arg) {
    while (arg.firstChild) {
      arg.removeChild(arg.firstChild);
    }
  },
  'setOptions': function (arg, arg2) {
    for (var value = 0, length = arg2.length; value < arg2.length; value++) {
      var el = document.createElement("option");
      el.value = arg2[value], el.innerHTML = arg2[value], arg.appendChild(el);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super(), this.playButton = this.querySelector('.internal-video__play'), this.noPlayBtn = this.dataset.noPlayBtn === "true", this.loaded = false, this.suspended = false, this.soundButton = this.querySelector('.internal-video__sound-btn'), this.video = this.querySelector("video"), this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) this.invalidFormatSrc.remove();
    this.timeline = this.querySelector('.internal-video__timeline'), this.dragging = false;
    if (this.playButton) this.playButton.addEventListener("click", this.playVideo.bind(this));
    if (this.soundButton) this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    if (this.video) this.video.addEventListener("ended", this.endedVideo.bind(this));
    this.timeline && (this.video.addEventListener('timeupdate', this.updateTimeline.bind(this)), this.timeline.addEventListener("click", this.seekVideo.bind(this)), this.timeline.addEventListener("mousedown", this.startDrag.bind(this)), this.timeline.addEventListener("touchstart", this.startDrag.bind(this)), document.addEventListener('mouseup', this.stopDrag.bind(this)), document.addEventListener("touchend", this.stopDrag.bind(this)), document.addEventListener('mousemove', this.drag.bind(this)), document.addEventListener("touchmove", this.drag.bind(this)));
    this.video.addEventListener("waiting", this.showSpinner.bind(this)), this.video.addEventListener('canplaythrough', this.hideSpinner.bind(this)), this.video.addEventListener('play', this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && 'IntersectionObserver' in window) {
      const config = {
        'root': null,
        'rootMargin': '0px',
        'threshold': 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), config), this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      !this.loaded && (this.video.load(), this.loaded = true);
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      const result = this.video.play();
      result !== undefined && result.then(() => {
        this.classList.add("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "hidden";
      }).catch(error => {
        this.classList.remove("internal-video--playing");
        if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = "visible";
      });
    } else this.video.pause(), this.classList.remove("internal-video--playing");
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    this.video.muted ? (this.video.muted = false, this.classList.remove("internal-video--muted")) : (this.video.muted = true, this.classList.add("internal-video--muted"));
  }
  updateTimeline() {
    const v = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty('--completed', v + '%');
  }
  hideSpinner() {
    this.classList.remove('internal-video--loading');
  }
  startDrag(event) {
    event.preventDefault(), this.dragging = true, this.drag(event);
  }
  stopDrag() {
    this.dragging = false;
  }
  ['drag'](arg) {
    if (!this.dragging) return;
    arg.touches && (arg = arg.touches[0]), this.seekVideo(arg);
  }
  seekVideo(event) {
    const rect = this.timeline.getBoundingClientRect(),
      v = event.clientX - rect.left,
      v2 = v / rect.width;
    this.video.currentTime = v2 * this.video.duration;
  }
  showSpinner() {
    this.classList.add('internal-video--loading');
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  ['handleIntersection'](arg) {
    arg.forEach(item => {
      if (item.isIntersecting) {
        for (let v of this.video.querySelectorAll('source[data-src]')) {
          v.setAttribute('src', v.getAttribute("data-src")), v.removeAttribute('data-src');
        }
        this.video.load();
        var result = this.video.play();
        result !== undefined && result.catch(error => {
          if (error.name === "NotAllowedError") {
            this.classList.remove('internal-video--playing');
            if (this.playButton && this.noPlayBtn) this.playButton.style.visibility = 'visible';
          }
        }).then(() => {
          this.video.play();
        }), this.observer.disconnect();
      }
    });
  }
}
customElements.define('internal-video', InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super(), this.sliderOverlay = this.querySelector('.comparison-slider__overlay'), this.sliderLine = this.querySelector(".comparison-slider__line"), this.sliderInput = this.querySelector('.comparison-slider__input'), this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  ['handleChange'](event) {
    const value = event.currentTarget.value;
    this.sliderOverlay.style.width = value + '%', this.sliderLine.style.left = value + '%';
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super(), this.testMode = this.dataset.testMode === "true", this.secondsDelay = this.dataset.delaySeconds, this.daysFrequency = this.dataset.delayDays, this.modal = this.querySelector(".sign-up-popup-modal"), this.timer = this.querySelector(".popup-modal__timer"), this.timerDuration = this.dataset.timerDuration, this.closeBtns = this.querySelectorAll(".promp-popup__close-btn"), this.overlay = document.querySelector('.sign-up-popup-overlay'), this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) this.openPopupModal();else {
        try {
          const data = JSON.parse(localStorage.getItem(this.storageKey)),
            date2 = new Date(data.next_display_date);
          currentDate.getTime() > date2.getTime() && this.openPopupModal();
        } catch (e) {
          localStorage.removeItem(this.storageKey), this.openPopupModal();
        }
      }
    } else {
      if (this.timer) this.displayPromoTimer();
    }
    this.closeBtns.forEach(item => {
      item.addEventListener('click', this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active"), this.overlay.classList.add("popup-overlay--active");
      const result = addDays(currentDate, parseInt(this.daysFrequency)),
        config = {
          'next_display_date': result,
          'dismissed': false
        };
      localStorage.setItem(this.storageKey, JSON.stringify(config));
      if (this.timer) this.displayPromoTimer();
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes"), this.secondsSpan = this.querySelector(".popup-modal__timer__seconds"), this.totalSeconds = parseFloat(this.timerDuration) * 60, this.updateTimer();
    this.promoTimerInterval = setInterval(() => {
      this.totalSeconds -= 1, this.updateTimer(), this.totalSeconds <= 0 && (this.totalSeconds = parseFloat(this.timerDuration) * 60 - 45);
    }, 1000);
  }
  updateTimer() {
    let result = Math.floor(this.totalSeconds / 60);
    if (result.toString().length === 1) result = '0' + result;
    let v = this.totalSeconds % 60;
    if (v.toString().length === 1) v = '0' + v;
    this.minutesSpan.innerText = result, this.secondsSpan.innerText = v;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active"), this.overlay.classList.remove("popup-overlay--active");
  }
  disconnectedCallback() {
    clearInterval(this.promoTimerInterval);
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super(), this.sectionOneContainer = this.querySelector(".section-group__section-one-container"), this.sectionTwoContainer = this.querySelector(".section-group__section-two-container"), this.transferSections(), document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping"), this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) this.sectionOneContainer.appendChild(this.sectionOne);
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) this.sectionTwoContainer.appendChild(this.sectionTwo);
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super(), this.button = this.querySelector(".clickable-discount__btn"), this.button.addEventListener("click", this.handleClick.bind(this)), this.dataset.applied === "true" ? this.handleClick() : this.reapplyDiscountIfApplicable();
  }
  handleClick() {
    this.dataset.loading = "true", this.button.disabled = true, this.dataset.error = "false", fetch("/discount/" + this.dataset.code).then(response => {
      if (!response.ok) throw new Error("Error");
      this.dataset.applied = "true", sessionStorage.setItem('discount-' + this.dataset.code + "-applied", "true");
    }).catch(error => {
      this.dataset.error = "true", this.button.disabled = false;
    }).finally(() => {
      this.dataset.loading = "false";
    });
  }
  ['reapplyDiscountIfApplicable']() {
    const code = this.dataset.code;
    sessionStorage.getItem('discount-' + code + "-applied") && (this.dataset.applied = 'true', this.button.disabled = true, setTimeout(() => {
      fetch("/discount/" + code).catch(error => {
        this.dataset.applied = "false", this.button.disabled = false;
      });
    }, 3000));
  }
}
customElements.define('clickable-discount', ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super(), this.dateFormat = this.dataset.dateFormat, this.days = this.rearrangeDays(this.dataset.dayLabels.split(',')), this.months = this.dataset.monthLabels.split(','), this.elementsToChange = this.querySelectorAll('[data-dynamic-date=\x22true\x22]'), this.insertDates(), checkDateValidity(currentDate), document.addEventListener("shopify:section:load", event => {
      this.insertDates();
    });
  }
  ['insertDates']() {
    this.elementsToChange.forEach(item => {
      const text = item.dataset.text,
        num = parseInt(item.dataset.minDays),
        num2 = parseInt(item.dataset.maxDays),
        result = addDays(currentDate, num);
      let value = 'th';
      const result2 = result.getDate();
      if (result2 === 1 || result2 === 21 || result2 === 31) value = 'st';else {
        if (result2 === 2 || result2 === 22) value = 'nd';else {
          if (result2 === 3 || result2 === 23) value = 'rd';
        }
      }
      const result3 = addDays(currentDate, num2);
      let value2 = 'th';
      const result4 = result3.getDate();
      if (result4 === 1 || result4 === 21 || result4 === 31) value2 = 'st';else {
        if (result4 === 2 || result4 === 22) value2 = 'nd';else {
          if (result4 === 3 || result4 === 23) value2 = 'rd';
        }
      }
      let v, v2;
      if (this.dateFormat === "day_dd_mm") v = this.days[result.getDay()] + ',\x20' + result.getDate() + '.\x20' + this.months[result.getMonth()], v2 = this.days[result3.getDay()] + ',\x20' + result3.getDate() + '.\x20' + this.months[result3.getMonth()];else {
        if (this.dateFormat === "mm_dd") v = this.months[result.getMonth()] + '\x20' + result.getDate() + value, v2 = this.months[result3.getMonth()] + '\x20' + result3.getDate() + value2;else {
          if (this.dateFormat === "dd_mm") v = result.getDate() + '.\x20' + this.months[result.getMonth()], v2 = result3.getDate() + '.\x20' + this.months[result3.getMonth()];else {
            if (this.dateFormat === "dd_mm_no_dot") v = result.getDate() + '\x20' + this.months[result.getMonth()], v2 = result3.getDate() + '\x20' + this.months[result3.getMonth()];else {
              if (this.dateFormat === 'day_dd_mm_numeric') {
                const value3 = String(result.getDate()).length > 1 ? result.getDate() : '0' + result.getDate(),
                  value4 = String(result.getMonth() + 1).length > 1 ? result.getMonth() + 1 : '0' + (result.getMonth() + 1);
                v = this.days[result.getDay()] + ',\x20' + value3 + '.\x20' + value4 + '.';
                const value5 = String(result3.getDate()).length > 1 ? result3.getDate() : '0' + result3.getDate(),
                  value6 = String(result3.getMonth() + 1).length > 1 ? result3.getMonth() + 1 : '0' + (result3.getMonth() + 1);
                v2 = this.days[result3.getDay()] + ',\x20' + value5 + '.\x20' + value6 + '.';
              } else {
                if (this.dateFormat === 'dd_mm_numeric') {
                  const value3 = String(result.getDate()).length > 1 ? result.getDate() : '0' + result.getDate(),
                    value4 = String(result.getMonth() + 1).length > 1 ? result.getMonth() + 1 : '0' + (result.getMonth() + 1);
                  v = value3 + '.\x20' + value4 + '.';
                  const value5 = String(result3.getDate()).length > 1 ? result3.getDate() : '0' + result3.getDate(),
                    value6 = String(result3.getMonth() + 1).length > 1 ? result3.getMonth() + 1 : '0' + (result3.getMonth() + 1);
                  v2 = value5 + '.\x20' + value6 + '.';
                } else v = this.days[result.getDay()] + ',\x20' + this.months[result.getMonth()] + '\x20' + result.getDate() + value, v2 = this.days[result3.getDay()] + ',\x20' + this.months[result3.getMonth()] + '\x20' + result3.getDate() + value2;
              }
            }
          }
        }
      }
      const result5 = text.replace("[start_date]", v),
        result6 = result5.replace("[end_date]", v2);
      item.innerHTML = result6;
    });
  }
  rearrangeDays(arg) {
    return arg.unshift(arg[6]), arg.length = 7, arg;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super(), this.isAfterScroll = this.dataset.afterScroll === "true", this.isScrollBtn = this.dataset.scrollBtn === "true", this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section), this.floatingBtns = document.querySelectorAll(".floating-btn"), this.footerSpacing();
    this.isAfterScroll ? this.mainAtcBtn && new IntersectionObserver(this.checkATCScroll.bind(this)).observe(this.mainAtcBtn) : this.floatingBtns.forEach(item => {
      item.style.setProperty("--sticky-atc-offset", this.offsetHeight + 'px');
    });
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector('.sticky-atc__scroll-btn'), this.scrollDestination = document.querySelector('' + this.dataset.scrollDestination.replace('id', this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
    }
  }
  checkATCScroll(entries) {
    // IntersectionObserver statt Scroll-Listener: offsetTop wandert bei
    // position:sticky-Infospalten mit und kippte die Sichtbarkeits-Bedingung
    // (Desktop-Leiste verschwand vor dem Seitenende). Leiste zeigen, sobald der
    // Haupt-ATC-Button oben aus dem Viewport gescrollt ist.
    const entry = entries[0],
      scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    scrolledPast ? (this.style.transform = 'none', this.scrolledPast = true) : (this.style.transform = '', this.scrolledPast = false), this.floatingBtns.forEach(item => {
      this.scrolledPast ? item.style.setProperty("--sticky-atc-offset", this.offsetHeight + 'px') : item.style.setProperty("--sticky-atc-offset", "0px");
    });
  }
  handleScrollBtn() {
    const el = document.querySelector("sticky-header"),
      value = el ? el.clientHeight : 0;
    window.scrollTo({
      'top': this.scrollDestination.offsetTop - value - 15,
      'behavior': "smooth"
    });
  }
  footerSpacing() {
    let el = document.querySelector(".sticky-atc-footer-spacer");
    if (el) return;
    el = document.createElement("div"), el.className = 'sticky-atc-footer-spacer', el.style.height = this.clientHeight - 1 + 'px', el.style.display = "block";
    const el2 = document.querySelector(".footer");
    if (el2) el.style.background = window.getComputedStyle(el2).background;
    document.body.appendChild(el);
  }
}
customElements.define("sticky-atc", StickyAtc), function () {
  if (!formatDates(currentDate, date)) {
    var value = 'shopify';
    if (!window.location.hostname.includes(value)) {
      if (document.querySelector('.m' + "ain-pr" + "oduct-fo" + 'rm')) document.querySelector('.m' + "ain-pr" + "oduct-fo" + 'rm').isCartUpsell = true;
    }
  }
}();
class BundleDeals extends HTMLElement {
  constructor() {
    super(), this.productContainers = this.querySelectorAll(".bundle-deals__product-js"), this.mediaItemContainers = this.querySelectorAll('.bundle-deals__media-item-container-js'), this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js"), this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js"), this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js"), this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.prices = this.querySelectorAll(".bundle-deals__price-js"), this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js"), this.totalPrice = this.querySelector(".bundle-deals__total-price-js"), this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js"), this.updatePrices = this.dataset.updatePrices === "true", this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.currencySymbol = this.dataset.currencySymbol, this.selectedVariants = {
      'id_1': null,
      'id_2': null,
      'id_3': null,
      'id_4': null,
      'id_5': null
    }, this.formVariants = [], this.initIds(), this.checkboxes.forEach(item => {
      item.addEventListener("change", this.handleCheckboxChange.bind(this));
    }), this.variantPickers.forEach(item => {
      item.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  ['initIds']() {
    this.checkboxes.forEach(item => {
      this.selectedVariants[item.dataset.idIndex] = {
        'id': item.dataset.id,
        'price': item.dataset.price,
        'comparePrice': item.dataset.comparePrice,
        'checked': true
      };
    }), this.updateFormIds();
  }
  handleCheckboxChange(event) {
    const currentTarget = event.currentTarget,
      checked = currentTarget.checked,
      num = parseInt(currentTarget.dataset.index);
    this.selectedVariants[currentTarget.dataset.idIndex].checked = checked;
    const num2 = this.productContainers[num],
      elements = num2.querySelectorAll("select");
    checked ? (this.mediaItemContainers[num].classList.remove("bundle-deals__media-item--disabled"), num2.classList.remove('bundle-deals__product--deselected'), elements.forEach(item => {
      item.removeAttribute("disabled");
    })) : (this.mediaItemContainers[num].classList.add('bundle-deals__media-item--disabled'), num2.classList.add('bundle-deals__product--deselected'), elements.forEach(item => {
      item.setAttribute("disabled", '');
    }));
    this.updateFormIds();
    if (this.updatePrices) this.updateTotalPrice();
  }
  ['handleSelectChange'](event) {
    const currentTarget = event.currentTarget,
      num = parseInt(currentTarget.dataset.index),
      list = Array.from(currentTarget.querySelectorAll("select"), arg => arg.value),
      result = JSON.parse(currentTarget.querySelector("[type=\"application/json\"]").textContent).filter(item => currentTarget.querySelector(':checked').value === item.option1),
      list2 = [...currentTarget.querySelectorAll('.select--small')];
    updateVariantStatuses(result, list2);
    const result2 = JSON.parse(currentTarget.querySelector('[type=\x22application/json\x22]').textContent).find(item => {
      return !item.options.map((item2, index) => {
        return list[index] === item2;
      }).includes(false);
    });
    if (!result2) {
      if (this.skipNonExistent) findAvailableVariant(currentTarget, list, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !result2.available) {
      if (findAvailableVariant(currentTarget, list, false, true, true)) return;
    }
    let {
      price: v,
      compare_at_price: v2,
      featured_image: v3
    } = result2;
    v = parseInt(v);
    let value = v2 ? parseInt(v2) : v;
    const value2 = currentTarget.dataset.percentageLeft ?? 1,
      value3 = currentTarget.dataset.fixedDiscount ?? 0;
    v = v * value2 - value3;
    if (v3) v3 = v3.src;
    const id = result2.id;
    this.selectedVariants[currentTarget.dataset.idIndex].id = id, this.selectedVariants[currentTarget.dataset.idIndex].price = v, this.selectedVariants[currentTarget.dataset.idIndex].comparePrice = value, this.updateFormIds(), this.updatePrices && (this.prices[num].innerHTML = this.currencySymbol + (v / 100).toFixed(2), value > v ? this.comparePrices[num].innerHTML = this.currencySymbol + (value / 100).toFixed(2) : this.comparePrices[num].innerHTML = '', this.updateTotalPrice()), v3 && v3.length > 0 && this.mediaItemImgs[num] && (this.mediaItemImgs[num].src = v3);
  }
  updateFormIds() {
    const list = [],
      selectedVariants = this.selectedVariants;
    for (const v in selectedVariants) {
      const v2 = selectedVariants[v];
      if (v2 != null && v2.checked) {
        const result = list.findIndex(arg => arg.id === v2.id);
        result < 0 ? list.unshift({
          'id': v2.id,
          'quantity': 1
        }) : list[result].quantity += 1;
      }
    }
    this.formVariants = list;
  }
  updateTotalPrice() {
    const list = [],
      list2 = [],
      selectedVariants = this.selectedVariants;
    for (const v2 in selectedVariants) {
      const v22 = selectedVariants[v2];
      v22 != null && v22.checked && (list.push(parseInt(v22.price)), list2.push(parseInt(v22.comparePrice)));
    }
    const result = list.reduce((item, index) => item + index, 0),
      v = result * this.percentageLeft - this.fixedDiscount,
      result2 = list2.reduce((item, index) => item + index, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (v / 100).toFixed(2), result2 > v ? this.totalComparePrice.innerHTML = this.currencySymbol + (result2 / 100).toFixed(2) : this.totalComparePrice.innerHTML = '';
  }
}
customElements.define('bundle-deals', BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super(), this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section), this.inputs = this.querySelectorAll('input[name=\x22quantity\x22]'), this.labels = this.querySelectorAll(".quantity-break"), this.jsonData = this.querySelector('[type=\x22application/json\x22]'), this.hasVariants = this.jsonData.dataset.hasVariants === "true", this.selectedVariants = {
      'input_1': [],
      'input_2': [],
      'input_3': [],
      'input_4': [],
      'input_5': [],
      'input_6': []
    }, this.updateUnavailable = this.dataset.updateUnavailable === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.formVariants = [], this.selectedQuantity = 1;
    if (this.querySelector("input[checked]")) this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item"), this.updatePrices = this.dataset.updatePrices === "true", this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) this.initVariants();
    this.inputs.forEach(item => {
      item.addEventListener("change", this.handleChange.bind(this));
    }), this.variantSelects.forEach(item => {
      item.addEventListener("change", this.handleSelectChange.bind(this));
    });
    refreshAtcPrice(this.dataset.section);
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget,
      list = Array.from(currentTarget.querySelectorAll('select'), arg => arg.value);
    if (this.updateUnavailable) {
      const result8 = this.getVariantData().filter(item => currentTarget.querySelector(":checked").value === item.option1),
        list2 = [...currentTarget.querySelectorAll(".select--small")];
      updateVariantStatuses(result8, list2);
    }
    const result = this.getVariantData().find(item => {
      return !item.options.map((item2, index) => {
        return list[index] === item2;
      }).includes(false);
    });
    if (!result) {
      if (this.skipNonExistent) findAvailableVariant(currentTarget, list, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !result.available) {
      if (findAvailableVariant(currentTarget, list, false, true, true)) return;
    }
    currentTarget.dataset.selectedId = result.id;
    const selectIndex = currentTarget.dataset.selectIndex,
      el = currentTarget.closest(".quantity-break"),
      input = el.dataset.input;
    this.selectedVariants[input][selectIndex] = result.id, this.formVariants = this.selectedVariants[input], this.updateMedia(result);
    if (!this.updatePrices) return;
    var value = 0,
      value2 = 0;
    const num = parseFloat(el.dataset.quantity),
      num2 = parseFloat(el.dataset.percentageLeft),
      num3 = parseFloat(el.dataset.fixedDiscount);
    for (let value3 = 0; value3 < num; value3++) {
      const num4 = parseInt(this.selectedVariants[input][value3]),
        result8 = this.getVariantData().find(item => parseInt(item.id) === num4);
      if (!result8) return;
      value += result8.price, result8.compare_at_price && result8.compare_at_price > result8.price ? value2 += result8.compare_at_price : value2 += result8.price;
    }
    value = value * num2 - num3;
    const v = value2 - value,
      v2 = Math.round(v / 100) * 100,
      v3 = value / num,
      v4 = value2 / num,
      result2 = formatMoney(value, this.moneyFormat, true),
      result3 = formatMoney(value2, this.moneyFormat, true),
      result4 = formatMoney(v, this.moneyFormat, true),
      result5 = formatMoney(v2, this.moneyFormat, true),
      result6 = formatMoney(v3, this.moneyFormat, true),
      result7 = formatMoney(v4, this.moneyFormat, true);
    el.querySelectorAll(".variant-price-update").forEach(item => {
      let text = item.dataset.text;
      text = text.replace('[quantity]', num), text = text.replace("[price]", result2), text = text.replace("[compare_price]", result3), text = text.replace("[amount_saved]", result4), text = text.replace('[amount_saved_rounded]', result5), text = text.replace("[price_each]", result6), text = text.replace("[compare_price_each]", result7), item.innerHTML = text;
    });
    const el2 = el.querySelector(".quantity-break__compare-price");
    el2 && (value2 > value ? el2.classList.remove("hidden") : el2.classList.add('hidden'));
  }
  ['getVariantData']() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) return;
    this.labels.forEach(item => {
      if (item.querySelector(".quantity-break__variants")) {
        let list = [];
        item.querySelectorAll(".quantity-break__selector-item").forEach(item2 => {
          list.push(item2.dataset.selectedId);
        }), this.selectedVariants[item.dataset.input] = list;
      }
    }), this.formVariants = [];
  }
  updateMedia(arg) {
    if (!arg) return;
    if (!arg.featured_media) return;
    const elements = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + '\x22]');
    elements.forEach(item => item.setActiveMedia(this.dataset.section + '-' + arg.featured_media.id, true));
  }
  handleChange(event) {
    const num = parseInt(event.target.value);
    this.selectedQuantity = num;
    if (this.hasVariants) this.formVariants = this.selectedVariants[event.target.dataset.input];
    if (this.quantityGifts) this.quantityGifts.unlockGifts(num);
    refreshAtcPrice(this.dataset.section);
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function updateVariantStatuses(arg, arg2) {
  arg2.forEach((item, index) => {
    if (index === 0) return;
    const list = [...item.querySelectorAll("option")],
      value = arg2[index - 1].querySelector(":checked").value,
      result = arg.filter(item2 => item2.available && item2["option" + index] === value).map(item2 => item2['option' + (index + 1)]),
      result2 = arg.filter(item2 => item2["option" + index] === value).map(item2 => item2["option" + (index + 1)]);
    list.forEach(item2 => {
      item2.classList.remove("unavailable", "non-existent"), result2.includes(item2.getAttribute("value")) ? result.includes(item2.getAttribute('value')) ? item2.innerText = item2.getAttribute("value") : (item2.innerText = window.variantStrings.unavailable_with_option.replace("[value]", item2.getAttribute('value')), item2.classList.add("unavailable")) : (item2.innerText = window.variantStrings.unavailable_with_option.replace('[value]', item2.getAttribute("value")), item2.classList.add("non-existent"));
    });
  });
}
function findAvailableVariant(arg, arg2, arg3 = true, arg4 = false, arg5 = false) {
  for (let v = arg2.length - 1; v >= 0; v--) {
    const value = arg3 ? arg.querySelector(".product-form__input:nth-child(" + (v + 1) + ')') : arg.querySelectorAll('.select')[v],
      value2 = arg3 ? value.querySelector(".product-form__input__type").dataset.type : 'dropdown',
      value3 = value2 === "dropdown" ? value.querySelectorAll("option") : value.querySelectorAll("input[type=\"radio\"]");
    let result = Array.from(value3).findIndex(arg6 => arg6.value === arg2[v]),
      v2 = false;
    while (result < value3.length - 1) {
      result++;
      const result2 = value3[result];
      if ((!arg4 || !result2.classList.contains("non-existent")) && (!arg5 || !result2.classList.contains("unavailable"))) {
        arg2[v] = result2.value, v2 = true;
        break;
      }
    }
    if (!v2) {
      result = Array.from(value3).findIndex(arg6 => arg6.value === arg2[v]);
      while (result > 0) {
        result--;
        const result2 = value3[result];
        if ((!arg4 || !result2.classList.contains("non-existent")) && (!arg5 || !result2.classList.contains("unavailable"))) {
          arg2[v] = result2.value, v2 = true;
          break;
        }
      }
    }
    if (v2) return value2 === "dropdown" ? value.querySelector('.select__select').value = arg2[v] : value.querySelector('input[type=\x22radio\x22][value=\x22' + arg2[v] + '\x22]').checked = true, arg.dispatchEvent(new Event("change")), true;
  }
  return false;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super(), this.gifts = this.querySelectorAll(".quantity-gift"), this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.quantitySelector = document.getElementById("Quantity-Form-" + this.dataset.section), this.unlockedItems = [], this.initUnlock();
  }
  initUnlock() {
    let value = 1;
    if (this.quantityBreaks) value = parseInt(this.quantityBreaks.selectedQuantity);else {
      if (this.quantitySelector) {
        const el = this.quantitySelector.querySelector('input[name=\x22quantity\x22]');
        value = parseInt(el.value);
      }
    }
    this.unlockGifts(value);
  }
  unlockGifts(arg) {
    this.unlockedItems = [], this.gifts.forEach(item => {
      parseInt(item.dataset.quantity) <= arg ? (item.classList.add("quantity-gift--unlocked"), item.dataset.unlocked = "true", this.unlockedItems.unshift(item.dataset.product)) : (item.classList.remove("quantity-gift--unlocked"), item.dataset.unlocked = 'false');
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super(), this.image = this.querySelector(".upsell__image__img"), this.toggleBtn = this.querySelector(".upsell-toggle-btn"), this.variantSelects = this.querySelector(".upsell__variant-picker"), this.variantSelectElements = this.querySelectorAll(".select__select"), this.jsonData = this.querySelector('[type=\x22application/json\x22]'), this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.updatePrices = this.dataset.updatePrices === "true", this.idInput = this.querySelector('product-form [name="id"]');
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price), this.comparePrice = parseInt(this.dataset.comparePrice), this.priceSpan = this.querySelector('.upsell__price\x20.regular-price'), this.comparePriceSpan = this.querySelector('.upsell__price\x20.compare-price'), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat, this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
    }
    if (this.toggleBtn) this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    if (this.variantSelects) this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
  }
  handleToggle(event) {
    if (event.target.nodeName.toLowerCase() === "select" || event.target.nodeName.toLowerCase() === 'option') return;
    this.dataset.selected === "true" ? this.dataset.selected = "false" : this.dataset.selected = "true";
  }
  handleSelectChange(event) {
    const currentTarget = event.currentTarget,
      list = Array.from(currentTarget.querySelectorAll('select'), arg => arg.value),
      result = this.getVariantData().find(item => {
        return !item.options.map((item2, index) => {
          return list[index] === item2;
        }).includes(false);
      }),
      result2 = this.getVariantData().filter(item => currentTarget.querySelector(":checked").value === item.option1),
      list2 = [...currentTarget.querySelectorAll("select")];
    updateVariantStatuses(result2, list2);
    if (!result) {
      if (this.skipNonExistent) findAvailableVariant(currentTarget, list, false, true, this.skipUnavailable);
      return;
    }
    if (this.skipUnavailable && !result.available) {
      if (findAvailableVariant(currentTarget, list, false, true, true)) return;
    }
    this.updatePrices && (this.price = result.price * this.percentageLeft - this.fixedDiscount, this.comparePrice = result.price, result.compare_at_price && result.compare_at_price > result.price && (this.comparePrice = result.compare_at_price), displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat));
    if (this.image && result.featured_image) this.image.src = result.featured_image.src;
    this.updateId(result.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) this.mainOfferContainer.updateTotalPrices();
  }
  updateId(arg) {
    this.dataset.id = arg;
    if (this.idInput) this.idInput.value = arg;
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.jsonData.textContent), this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super(), this.cartDrawer = document.querySelector('cart-drawer'), this.cartItems = this.cartDrawer.querySelector("cart-drawer-items"), this.productForm = this.querySelector('product-form'), this.idInput = this.productForm.querySelector("[name=\"id\"]"), this.classicAddButton = this.querySelector('.upsell__add-btn');
  }
  handleToggle(event) {
    if (event.target.nodeName.toLowerCase() === 'select' || event.target.nodeName.toLowerCase() === 'option') return;
    this.dataset.selected === "true" ? (this.dataset.selected = "false", this.removeFromCart()) : (this.dataset.selected = 'true', this.addToCart());
  }
  // 20.0.6: Zeilen-Identitaet als Methode — Toggle-Upsells bleiben handle-basiert, CartDrawerGift ueberschreibt mit dem _sc_gift-Marker
  lineInCart() {
    return this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
  }
  addRemoveFromCart() {
    this.dataset.selected === "true" && !this.cartDrawer.classList.contains('is-empty') ? this.addToCart() : this.removeFromCart();
  }
  addToCart() {
    const el = this.lineInCart();
    if (el) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute('disabled', '');
    this.variantSelectElements.forEach(item => {
      item.setAttribute('disabled', '');
    }), this.productForm.handleSubmit();
  }
  removeFromCart() {
    const el = this.lineInCart();
    if (!el || !this.cartItems) return;
    if (this.toggleBtn) this.toggleBtn.setAttribute("disabled", '');
    this.variantSelectElements.forEach(item => {
      item.setAttribute("disabled", '');
    }), this.cartItems.updateQuantity(el.dataset.index, 0);
  }
  updateId(arg) {
    this.dataset.id = arg, this.idInput.value = arg;
    if (this.classicAddButton) return;
    if (this.dataset.selected === "true") {
      this.selectTimeout && clearTimeout(this.selectTimeout);
      this.removeFromCart();
      const v = event => {
        event.detail.handle === "handle" && (this.addToCart(), document.removeEventListener('cartQuantityUpdated', v));
      };
      document.addEventListener("cartQuantityUpdated", v);
    }
  }
  getUpdateRequired() {
    const el = this.lineInCart();
    let v = false;
    if (el && this.dataset.selected === 'false') v = true;else !el && this.dataset.selected === "true" && (v = true);
    return v;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(arg, arg2, arg3, arg4, arg5) {
  if (!arg5) return;
  if (arg && arg3) {
    var result = formatMoney(arg, arg5);
    arg3.innerHTML = result;
  }
  if (arg2 && arg4) {
    var result2 = formatMoney(arg2, arg5);
    arg4.innerHTML = result2, arg2 > arg ? arg4.classList.remove("hidden") : arg4.classList.add("hidden");
  }
}
function formatMoney(arg, arg2, arg3 = false) {
  typeof arg == 'string' && (arg = arg.replace('.', ''));
  var value = '',
    value2 = /\{\{\s*(\w+)\s*\}\}/,
    v = arg2;
  function fn(arg4, arg5) {
    return typeof arg4 == 'undefined' ? arg5 : arg4;
  }
  function fn2(arg4, arg5, arg6, arg7) {
    arg5 = fn(arg5, 2), arg6 = fn(arg6, ','), arg7 = fn(arg7, '.');
    if (isNaN(arg4) || arg4 == null) return 0;
    arg4 = (arg4 / 100).toFixed(arg5);
    var result = arg4.split('.'),
      result2 = result[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + arg6),
      value3 = result[1] ? arg7 + result[1] : '';
    return arg3 && value3 === arg7 + '00' && (value3 = ''), result2 + value3;
  }
  switch (v.match(value2)[1]) {
    case 'amount':
      value = fn2(arg, 2);
      break;
    case "amount_no_decimals":
      value = fn2(arg, 0);
      break;
    case 'amount_with_comma_separator':
      value = fn2(arg, 2, '.', ',');
      break;
    case "amount_no_decimals_with_comma_separator":
      value = fn2(arg, 0, '.', ',');
      break;
    // 20.0.6-Korrektur (Codex C2-2): die vier restlichen Shopify-Formate (Doku money_format)
    case 'amount_with_space_separator':
      value = fn2(arg, 2, ' ', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = fn2(arg, 2, "'", '.');
      break;
    case 'amount_no_decimals_with_space_separator':
      value = fn2(arg, 0, ' ', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = fn2(arg, 2, ' ', '.');
      break;
  }
  return v.replace(value2, value);
}
// 20.0.6: Button-/Sticky-Preis folgt der Menge. Spiegel von quantity-breaks.liquid (price x qty x percentage_left - fixed_amount_off, Cent);
// Math.round auf Cent = Shopify money-Filter. Ohne Span/Attribute No-op (display_price aus, Drawer-Stepper ohne data-section).
function updateAtcPrice(sectionId, quantity, percentageLeft = 1, fixedDiscount = 0) {
  const qty = parseInt(quantity, 10);
  if (isNaN(qty) || qty < 1) return;
  ["main-atc-price-", "sticky-atc-price-"].forEach(prefix => {
    const el = document.getElementById(prefix + sectionId);
    if (!el || !el.dataset.unitPrice || !el.dataset.moneyFormat) return;
    // 20.0.6-Korrektur (Codex C2-2): unbekanntes Format -> Liquid-Preis unangetastet lassen statt leer/Throw
    if (!/\{\{\s*amount(_no_decimals)?(_with_comma_separator|_with_space_separator|_with_apostrophe_separator|_with_period_and_space_separator)?\s*\}\}/.test(el.dataset.moneyFormat)) return;
    const unit = parseInt(el.dataset.unitPrice, 10);
    if (isNaN(unit)) return;
    const total = Math.round(unit * qty * percentageLeft - fixedDiscount);
    el.innerHTML = formatMoney(total, el.dataset.moneyFormat) + " •";
  });
}
// Aufloesung: gecheckte Mengenrabatt-Kachel gewinnt (mit ihrem Rabatt), sonst der Mengen-Stepper, sonst 1.
function refreshAtcPrice(sectionId) {
  const breaks = document.getElementById("quantity-breaks-" + sectionId),
    checked = breaks ? breaks.querySelector('input[name="quantity"]:checked') : null;
  if (checked) {
    const label = breaks.querySelector('.quantity-break[data-input="' + checked.dataset.input + '"]'),
      pl = label ? parseFloat(label.dataset.percentageLeft) : NaN,
      fd = label ? parseFloat(label.dataset.fixedDiscount) : NaN;
    updateAtcPrice(sectionId, checked.value, isNaN(pl) ? 1 : pl, isNaN(fd) ? 0 : fd);
    return;
  }
  const input = document.getElementById("Quantity-" + sectionId);
  updateAtcPrice(sectionId, input ? input.value : 1);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
  // 20.0.6: nur die vom Block selbst angelegte Zeile (properties[_sc_gift] = block.id) zaehlt; Rueckfall auf Handle nur ohne data-gift
  lineInCart() {
    return this.dataset.gift ? this.cartDrawer.querySelector('.cart-item[data-gift="' + CSS.escape(this.dataset.gift) + '"]') : super.lineInCart();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const el = document.querySelector('cart-drawer');
  el && el.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(item => {
    if (item.addRemoveFromCart) item.addRemoveFromCart();
  });
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super(), this.offerItems = this.querySelectorAll(".main-offer-item"), this.updatePrices = this.dataset.updatePrices === "true", this.updatePrices && (this.priceSpan = this.querySelector(".bundle-deals__total-price-js"), this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js"), this.percentageLeft = parseFloat(this.dataset.percentageLeft), this.fixedDiscount = parseFloat(this.dataset.fixedDiscount), this.moneyFormat = this.dataset.moneyFormat);
  }
  updateTotalPrices() {
    if (!this.updatePrices) return;
    var value = 0,
      value2 = 0;
    for (let value3 = 0; value3 < this.offerItems.length; value3++) {
      value += parseInt(this.offerItems[value3].price), value2 += parseInt(this.offerItems[value3].comparePrice);
    }
    value = value * this.percentageLeft - this.fixedDiscount, displayPrices(value, value2, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name, this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea"), this.inputRadios = this.querySelectorAll('[type=\x22radio\x22]'), this.select = this.querySelector('.select__select'), this.productForm = document.getElementById("product-form-" + this.dataset.section), this.prevValue = this.dataset.defaultValue, this.isRequired = this.dataset.required === "true", this.isText = true, this.notMain = this.dataset.notMain === 'true';
    if (this.dataset.type === "select" || this.dataset.type === "pills") this.isText = false;
    this.createInputs();
    this.isRequired && this.isText && (this.isValid = true, this.atcButtons = this.notMain ? document.querySelectorAll('.featured-product-atc-' + this.dataset.section) : document.querySelectorAll(".main-product-atc"), this.mainAtcButton = this.productForm.querySelector('#ProductSubmitButton-' + this.dataset.section), this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label"), this.mainAtcBtnError = this.mainAtcButton.querySelector('.main-atc__error'), this.atcErrorMsg = this.dataset.atcErrorMsg, this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1, this.mainAtcBtnError.innerHTML = this.atcErrorMsg, this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true", this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section), this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector('.sticky-atc__label'), this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error"), this.stickyAtcBtnError.innerHTML = this.atcErrorMsg), this.validateValue(this.prevValue, null));
    if (this.input) this.input.addEventListener("input", this.handleChange.bind(this));
    this.inputRadios.forEach(item => {
      item.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) this.select.addEventListener("change", this.handleChange.bind(this));
  }
  handleChange(event) {
    const result = event.target.value.trim();
    if (event.target.checkValidity()) this.prevValue = result;else {
      event.target.value = this.prevValue;
      return;
    }
    this.dataset.value = result, this.productFormInput.value = result;
    if (this.isRequired && this.isText) this.validateValue(result, event.target);
  }
  validateValue(arg, arg2) {
    const value = arg.length > 0 ? true : false;
    if (value === this.isValid) return;
    this.isValid = value;
    arg2 && (this.isValid ? (arg2.classList.remove("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1) : (arg2.classList.add("input--error"), this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1));
    const v = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields,
      v2 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(item => {
      v && !v2 ? item.removeAttribute("disabled") : item.setAttribute("disabled", '');
    });
    if (this.atcErrorMsg.length === 0) return;
    v ? (this.mainAtcBtnLabel.style.display = '', this.mainAtcBtnError.style.display = "none", this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = '', this.stickyAtcBtnError.style.display = "none")) : (this.mainAtcBtnLabel.style.display = "none", this.mainAtcBtnError.style.display = '', this.applyStickyAtcError && this.stickyAtcButton && (this.stickyAtcBtnLabel.style.display = 'none', this.stickyAtcBtnError.style.display = ''));
  }
  createInputs() {
    this.productFormInput = document.createElement("input"), this.productFormInput.setAttribute("type", 'hidden'), this.productFormInput.setAttribute("name", "properties[" + this.fieldName + ']'), this.productFormInput.value = this.dataset.defaultValue, this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super(), this.secondarySelectSelector = "StickyAtcVariantPicker-", this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section), this.isSecondary = false, this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section), this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true", this.prependMedia = this.dataset.disablePrepend != "true", this.filtering = this.dataset.hasFiltering === "true", this.skipNonExistent = this.dataset.skipNonExistent === "true", this.skipUnavailable = this.dataset.skipUnavailable === "true", this.hasQuantityBreaksPicker && (this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle, this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages), this.addEventListener('change', this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(true, '', false), this.updatePickupAvailability(), this.removeErrorMessage(), this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) return;
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) return;
      }
      this.updateMedia(), this.updateURL(), this.updateVariantInput(), this.renderProductInfo(), this.updateShareUrl();
    }
  }
  updateOptions() {
    const list = [];
    this.querySelectorAll(".product-form__input").forEach(item => {
      let v;
      const type = item.querySelector(".product-form__input__type").dataset.type;
      type == 'dropdown' || type == "dropdwon" ? v = item.querySelector('.select__select').value : v = item.querySelector("input[type=\"radio\"]:checked").value, list.push(v);
    }), this.options = list;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(item => {
      return !item.options.map((item2, index) => {
        return this.options[index] === item2;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const elements = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + '\x22]');
    elements.forEach(item => item.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const el = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!el) return;
    const el2 = el.querySelector('[data-media-id=\x22' + this.currentVariant.featured_media.id + '\x22]');
    if (el2) el.prepend(el2);
  }
  ['updateURL']() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, '', this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  ['updateShareUrl']() {
    const el = document.getElementById('Share-' + this.dataset.section);
    if (!el || !el.updateUrl) return;
    el.updateUrl('' + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  ['updateVariantInput']() {
    const elements = document.querySelectorAll('#product-form-' + this.dataset.section + ',\x20#product-form-installment-' + this.dataset.section);
    elements.forEach(item => {
      const el = item.querySelector("input[name=\"id\"]");
      el.value = this.currentVariant.id, el.dispatchEvent(new Event("change", {
        'bubbles': true
      }));
    });
  }
  updateVariantStatuses() {
    const result = this.variantData.filter(item => this.querySelector(":checked").value === item.option1);
    let v;
    this.isSecondary && this.secondarySelect ? v = [...this.secondarySelect.querySelectorAll('.product-form__input')] : v = [...this.querySelectorAll(".product-form__input")], v.forEach((item, index) => {
      if (index === 0) return;
      const list = [...item.querySelectorAll("input[type=\"radio\"], .select__select option")],
        value = v[index - 1].querySelector(":checked").value,
        result2 = result.filter(item2 => item2.available && item2['option' + index] === value).map(item2 => item2["option" + (index + 1)]),
        result3 = result.filter(item2 => item2["option" + index] === value).map(item2 => item2["option" + (index + 1)]);
      this.setInputAvailability(list, result2, result3);
    });
  }
  setInputAvailability(arg, arg2, arg3) {
    arg.forEach(item => {
      item.classList.remove("unavailable", 'non-existent', 'disabled');
      const attr = item.getAttribute("value");
      let value = null;
      item.dataset.swatch === "true" && (value = item.closest(".color-swatch"));
      if (value) value.classList.remove('unavailable', 'non-existent', 'disabled');
      if (arg3.includes(attr)) {
        if (arg2.includes(attr)) {
          if (item.nodeName === "OPTION") item.innerText = attr;else {
            item.classList.remove("disabled");
            if (value) value.classList.remove("disabled");
          }
        } else {
          if (item.nodeName === "OPTION") item.innerText = window.variantStrings.unavailable_with_option.replace("[value]", attr), item.classList.add("unavailable");else {
            item.classList.add('disabled', "unavailable");
            if (value) value.classList.add("disabled", "unavailable");
          }
        }
      } else {
        if (item.nodeName === "OPTION") item.innerText = window.variantStrings.unavailable_with_option.replace('[value]', attr), item.classList.add("non-existent");else {
          item.classList.add("disabled", 'non-existent');
          if (value) value.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const el = document.querySelector('pickup-availability');
    if (!el) return;
    if (this.currentVariant && this.currentVariant.available) {
      if (el.fetchAvailability) el.fetchAvailability(this.currentVariant.id);
    } else el.removeAttribute("available"), el.innerHTML = '';
  }
  removeErrorMessage() {
    const el = this.closest('section');
    if (!el) return;
    const el2 = el.querySelector("product-form");
    if (el2) el2.handleErrorMessage();
  }
  renderProductInfo() {
    const id = this.currentVariant.id,
      value = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + id + '&section_id=' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + '&_=' + Date.now()).then(response => response.text()).then(response => {
      if (this.currentVariant.id !== id) return;
      const result = new DOMParser().parseFromString(response, "text/html"),
        el = document.getElementById("price-" + this.dataset.section),
        el2 = result.getElementById('price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el3 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section),
        el4 = result.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el5 = document.getElementById("sticky-atc-price-" + this.dataset.section),
        el6 = result.getElementById('sticky-atc-price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el7 = document.getElementById("sticky-atc-image-" + this.dataset.section),
        el8 = result.getElementById('sticky-atc-image-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el9 = document.getElementById("main-atc-price-" + this.dataset.section),
        el10 = result.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        elements = document.querySelectorAll('[id^=\x22custom-label-' + this.dataset.section + '\x22]'),
        elements2 = result.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + '\x22]'),
        el11 = result.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el12 = document.getElementById("Sku-" + this.dataset.section),
        el13 = result.getElementById('Inventory-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
        el14 = document.getElementById("Inventory-" + this.dataset.section);
      if (el && el2) el.innerHTML = el2.innerHTML;
      if (el3 && el4) el3.innerHTML = el4.innerHTML;
      if (el5 && el6) { el5.innerHTML = el6.innerHTML; el5.dataset.unitPrice = el6.dataset.unitPrice; }
      if (el7 && el8) el7.src = el8.src;
      if (el10 && el9) { el9.innerHTML = el10.innerHTML; el9.dataset.unitPrice = el10.dataset.unitPrice; }
      if (elements && elements2) for (var value2 = 0; value2 < elements.length; value2++) {
        elements[value2].innerHTML = elements2[value2].innerHTML;
      }
      if (el13 && el14) {
        // Voll-Sync noetig: --inv-pct/--inv-color leben im style-Attribut, product__inventory--low in der Klasse
        el14.innerHTML = el13.innerHTML;
        el14.setAttribute("style", el13.getAttribute("style") || "");
        el14.className = el13.className;
      }
      el11 && el12 && (el12.innerHTML = el11.innerHTML, el12.classList.toggle("visibility-hidden", el11.classList.contains("visibility-hidden")));
      if (this.QuantityBreaks) {
        const el17 = result.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          elements3 = this.QuantityBreaks.querySelectorAll(".dynamic-price"),
          elements4 = el17.querySelectorAll('.dynamic-price');
        for (let value3 = 0; value3 < elements3.length; value3++) {
          elements3[value3].innerHTML = elements4[value3].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(item => {
            item.dataset.selectedId = this.currentVariant.id;
          });
          const elements5 = this.QuantityBreaks.querySelectorAll('.quantity-break__variant-select'),
            elements6 = el17.querySelectorAll(".quantity-break__variant-select");
          for (let value3 = 0; value3 < elements5.length; value3++) {
            elements5[value3].innerHTML = elements6[value3].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        ;
      }
      if (this.hasQuantityBreaksPicker) {
        const el17 = result.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)),
          elements3 = this.querySelectorAll(".dynamic-price"),
          elements4 = el17.querySelectorAll('.dynamic-price');
        for (let value3 = 0; value3 < elements3.length; value3++) {
          elements3[value3].innerHTML = elements4[value3].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === 'vertical' && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const elements5 = this.querySelectorAll('.quantity-break__image\x20img'),
            elements6 = el17.querySelectorAll(".quantity-break__image img");
          for (let value3 = 0; value3 < elements5.length; value3++) {
            elements5[value3].src = elements6[value3].src;
          }
        }
      }
      if (this.secondarySelect) {
        const el17 = result.getElementById('' + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (el17) this.secondarySelect.innerHTML = el17.innerHTML;
      }
      const el15 = document.getElementById("price-" + this.dataset.section);
      if (el15) el15.classList.remove('visibility-hidden');
      if (el14 && el13) el14.classList.toggle("visibility-hidden", el13.innerText === '');
      const el16 = result.getElementById("ProductSubmitButton-" + value);
      this.toggleAddButton(el16 ? el16.hasAttribute('disabled') : true, window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
        'data': {
          'sectionId': value,
          'html': result,
          'variant': this.currentVariant
        }
      });
      refreshAtcPrice(this.dataset.section);
    });
  }
  toggleAddButton(arg = true, arg2, arg3 = true) {
    const el = document.getElementById("product-form-" + this.dataset.section);
    if (!el) return;
    const el2 = el.querySelector("[name=\"add\"]"),
      elements = document.querySelectorAll('.main-product-atc');
    var el3 = el.querySelector(".main-atc__label__text");
    if (!el3) el3 = el.querySelector(".main-atc__label");
    const el4 = el.querySelector(".main-atc-price");
    if (!el2) return;
    if (arg) {
      el2.setAttribute("disabled", 'disabled'), el2.setAttribute('data-unavailable', "true");
      if (arg2) el3.textContent = arg2;
      elements.forEach(item => {
        item.setAttribute("disabled", "disabled");
      });
      if (el4) el4.classList.add("hidden");
    } else {
      el2.setAttribute("data-unavailable", "false"), el3.textContent = window.variantStrings.addToCart;
      if (el4) el4.classList.remove('hidden');
      el2.dataset.requiredFields === el2.dataset.validFields && (el2.removeAttribute("disabled"), elements.forEach(item => {
        item.removeAttribute('disabled');
      }));
    }
    if (!arg3) return;
  }
  setUnavailable() {
    const el = document.getElementById('product-form-' + this.dataset.section);
    if (!el) return;
    const el2 = el.querySelector("[name=\"add\"]");
    var el3 = el.querySelector(".main-atc__label__text");
    if (!el3) el3 = el.querySelector(".main-atc__label");
    const el4 = document.getElementById("price-" + this.dataset.section),
      el5 = document.getElementById("Inventory-" + this.dataset.section),
      el6 = document.getElementById("Sku-" + this.dataset.section);
    if (!el2) return;
    el3.textContent = window.variantStrings.unavailable;
    if (el4) el4.classList.add('visibility-hidden');
    if (el5) el5.classList.add("visibility-hidden");
    if (el6) el6.classList.add("visibility-hidden");
  }
  getVariantData() {
    return this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent), this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = 'variant-selects-', this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section), this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(',');
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super(), this.secondarySelectSelector = 'variant-selects-', this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section), this.isSecondary = true;
  }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super(), this.quickAddSubmit = document.getElementById(this.dataset.section + '-submit');
  }
  onVariantChange() {
    this.updateOptions(), this.updateMasterId(), this.toggleAddButton(true, '', false), this.updateVariantStatuses(), !this.currentVariant ? (this.toggleAddButton(true, '', true), this.setUnavailable()) : (this.updateMedia(), this.updateVariantInput(), this.updateQuickAddUrl(), this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut));
  }
  ['updateMedia']() {
    if (!this.currentVariant || !this.currentVariant.featured_media) return;
    const el = document.getElementById(this.dataset.section + "-image");
    if (!el) return;
    const preview_image = this.currentVariant.featured_media.preview_image,
      v = preview_image.src.split('?')[0],
      list = [165, 360, 533, 720, 940, 1066],
      result = list.filter(item => preview_image.width >= item).map(item => v + "?width=" + item + '\x20' + item + 'w').join(',\x20');
    el.srcset = result + ',\x20' + v + '\x20' + preview_image.width + 'w', el.src = v + "?width=533";
  }
  ['updateQuickAddUrl']() {
    if (!this.currentVariant || !this.quickAddSubmit) return;
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);
